import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="card p-8 text-center">
      <div className="text-2xl font-semibold text-slate-50">404</div>
      <div className="text-slate-400 mt-1">That page doesn’t exist.</div>
      <Link to="/dashboard" className="btn-primary mt-4 inline-block">
        Back to dashboard
      </Link>
    </div>
  );
}
